import React, { useContext } from 'react';

import { ConfigContext } from '../../../context';

const Address = dealer => {
  const { config, itemPropMap } = useContext(ConfigContext);
  const dealerFields = config.addressFields.filter(
    field => dealer[field] !== ''
  );
  let lastField;

  // Japan has different way to write the address, don't show commas and add line break after zipcode
  const isJp = document.body.dataset.language === 'jp_JP';

  return (
    <>
      {dealerFields.map((field, fieldIndex) => {
        const showComma = fieldIndex > 0 && lastField !== 'streetaddress' && !isJp;
        const itemProp = field in itemPropMap ? itemPropMap[field] : '';

        lastField = field;

        return dealer[field] === '' ? null : (
          <React.Fragment key={dealer.slug + field}>
            {showComma ? ', ' : null}
            <span itemProp={itemProp}>{dealer[field]}</span>
            {(field === 'streetaddress' && !isJp) || (field ==='zipcode' && isJp) ? <br /> : null}
          </React.Fragment>
        );
      })}
    </>
  );
};

export default Address;
